export default function Logo({ size = 44 }) {
  return (
    <img
      src="/obfz-logo-v2.png"
      width={size}
      height={size}
      alt="ObFZ Levice"
      className="object-contain"
      style={{ width: size, height: size }}
    />
  );
}
